import axios from "axios";

export const getLoggedInState = () => {
  return axios.get(
    `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/login`
  );
};
export const activateFromEmail = (code) => {
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/register/email/activation/${code}`,
    data: {}
  });
};
export const requestOtp = (username, password, recaptcha) => {
  username && (username = username.trim());
  password && (password = password.trim());
  const data = {
    subscription: username,
    password: password
  };
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/login/tfa/otp/request`,
    data,
    // headers: { "X-RECAPTCHA": "03AFcWeA4zvfRbn1sKnM6wQjriB1hzsZ5IMjdxCaiUtOaemA79J6g8zG86pwc6z-ZEx5ViHhNy4618oi921ZCvbML3JkfO27F8N4gS9FXGUyiQXBDe3QoytDbTDbNFBQJvNgFVumIjShVh4axkpHQv6JKYbNUymDpH--vGzvaWO9MMYcM8Iu6dtgyUkZmXhWEeLgyhe9Xo-ludEctLqBHfGoX_MeinmvP3jsIQVzYOIFgDpMvcJNeO9Duia7AhixG0KBBLUIQPgZUrrwI9e8DNox3nSXRjzdT-R_crsao9rGZ82uW-Czpx5A6OSm_fUAlXhPK7pOpFEAlsRPndj2vWy8v1C-lPXz6bcQ42dux7VLraLNAFRQyiaVoH1WKDSIjmPknDWOxsp1vaJKsfJTQwfq05N4UQOveluBJNCEj8anNz3EEeFbQigvP0MB6z19XJqN9Rvu5pdjixZBHuQ2ZyXBbrWZ8SPIZDof-urGuOicCEAZ_bRocRPS4TAeBR9SWxtvl5ProwEbe70wM33MaEQMxDlaCZd_Xn01fzxkhduZFhHk9JzhUg3BRM6psSw6IU8-niQB4IXDg8H_ImOxk1bKAo08Gr-gNg5MJtiNxQ-hBUBEqPKRV9566fvF_h4OGNuypyXPWEFRprIzfV0K8M6Y3hSRhxgY-p1_-k8FmhsuwbWW9033AUIdk" }
  });
};

export const loginPassword = (username, password, redirectUrl) => {
  username && (username = username.trim());
  password && (password = password.trim());
  const data = {
    username,
    password
  };
  if (redirectUrl) {
    data.redirectURL = redirectUrl;
  }
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_URL}/cloud/login/v3/login`,
    data,
    headers: { "X-LOGIN-METHOD": "DID" }
  });
};

export const forgotPassword = (subscription, recaptcha) => {
  subscription && (subscription = subscription.trim());
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/${subscription}/password/otp/request`,
    data: { subscription, recaptcha },
    headers: { "X-RECAPTCHA": recaptcha }
  });
};

export const validateForgotPassword = (subscription, pin) => {
  subscription && (subscription = subscription.trim());
  pin && (pin = pin.trim());
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/${subscription}/password/otp/validate`,
    data: { pin }
  });
};

export const changePassword = (subscription, password) => {
  subscription && (subscription = subscription.trim());
  password && (password = password.trim());
  return axios({
    method: "PUT",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/${subscription}/password/reset`,
    data: { password },
    headers: { "X-LOGIN-METHOD": "DIDOTP" }
  });
};

export const usernameLogin = (username, recaptcha) => {
  username && (username = username.trim());
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/${username}/forgot/username`,
    data: { username },
    headers: { "X-RECAPTCHA": recaptcha }
  });
};

export const loginOtp = (username, password, redirectUrl) => {
  username && (username = username.trim());
  password && (password = password.trim());
  const data = {
    username,
    password
  };
  if (redirectUrl) {
    data.redirectURL = redirectUrl
  }

  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_LOGIN_URL}/login/v3/login`,
    data,
    headers: {
      "X-LOGIN-METHOD": "DIDOTP"
    }
  });
};

export const otpRegister = (
  username,
  firstname,
  msisdn,
  password,
  recaptcha
) => {
  username && (username = username.trim());
  password && (password = password.trim());
  firstname && (firstname = firstname.trim());
  msisdn && (msisdn = msisdn.trim());
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/register/otp`,
    data: { username, firstname, msisdn, password },
    headers: { "X-RECAPTCHA": recaptcha }
  });
};

export const validateOtpRegister = (username, msisdn, otp) => {
  username && (username = username.trim());
  msisdn && (msisdn = msisdn.trim());
  otp && (otp = otp.trim());
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_REST_URL}/v1/profile/manage/register/verify`,
    data: { username, msisdn, otp },
    headers: { "X-LOGIN-METHOD": "DIDOTP" }
  });
};
